export const SAVE_ALL_FINANCIAL_REPORTS = 'SAVE_ALL_FINANCIAL_REPORTS'